<template>
  <div class="main">
    <!-- channel banner -->
    <div class="cbanner">
      <img src="../../assets/images/banner_ucenter.jpg" />
      <div class="btext">
        <h3>我的借贷</h3>
        <p>最低投资成本，最好的安全保证，专业互联网借贷信息中介平台</p>
      </div>
    </div><!-- channel banner END-->
    <div class="main_inner">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <span class="btitle">当前位置：</span>
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户中心</el-breadcrumb-item>
        <el-breadcrumb-item>我的借贷</el-breadcrumb-item>
      </el-breadcrumb>
      <el-row>
        <el-col :span="5" class="leftside">
          <el-menu
            default-active="3"
            class="el-menu-vertical-demo">
            <router-link :to="{ path: '/personalInformation' }">
              <el-menu-item index="1"><span slot="title" >个人信息</span></el-menu-item>
            </router-link>
            <router-link :to="{ path: '/passwordEdit' }">
              <el-menu-item index="2"><span slot="title">修改密码</span></el-menu-item>
            </router-link>
            <router-link :to="{ path: '/myBorrow' }">
              <el-menu-item index="3"><span slot="title">我的借贷</span></el-menu-item>
            </router-link>
          </el-menu>
        </el-col>
        <el-col :span="19">
          <div class="con_right mylist_con">
            <!-- my list -->
            <div class="con mylist">
                <h1>我的意向</h1>
                <h3>借入意向
                  <div class="static"> <router-link :to="{ path: '/myBorrowIntentionPage' }">更多</router-link></div>
                </h3>
                <template>
                  <el-table
                    :data="borrowIntention"
                    style="width: 100%">
                    <el-table-column
                      prop="type"
                      label="意向类型" :formatter="formatType">
                    </el-table-column>
                    <el-table-column
                      prop="contractAmount"
                      label="意向金额(元)">
                    </el-table-column>
                    <el-table-column
                      prop="createTime"
                      label="意向发送时间" :formatter="formatCreateTime">
                    </el-table-column>

                    <el-table-column
                      prop="projectName"
                      label="项目名称"
                      width="180">
                    </el-table-column>
                    <el-table-column
                      prop="disposeStatus"
                      label="当前状态" :formatter="formatDisposeStatus" >
                    </el-table-column>
                    <el-table-column
                      label="操作">
                      <template slot-scope="scope">
                        <el-button type="default" :disabled="(scope.row.projectName=='')" @click="selectBorrowProject(scope.$index,scope.row)" size="small" v-if="this.projectName=''?readOnly=false:true">查看项目</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
            </div>
            <div class="con mylist mt_42">
              <h3>出借意向
                <div class="static"> <router-link :to="{ path: '/myLoanIntentionPage' }">更多</router-link></div>
              </h3>
              <template>
                <el-table
                  :data="lanIntention"
                  style="width: 100%">
                  <el-table-column
                    prop="type"
                    label="意向类型" :formatter="formatType">
                  </el-table-column>
                  <el-table-column
                    prop="contractAmount"
                    label="意向金额(元)" >
                  </el-table-column>
                  <el-table-column
                    prop="createTime"
                    label="意向发送时间" :formatter="formatCreateTime">
                  </el-table-column>

                  <el-table-column
                    prop="projectName"
                    label="项目名称"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="disposeStatus"
                    label="当前状态" :formatter="formatDisposeStatus" >
                  </el-table-column>
                  <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                      <el-button type="default" :disabled="(scope.row.projectName=='')" @click="selectLanProject(scope.$index,scope.row)" size="small">查看项目</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </div>

            <div class="con mylist mt_42">
              <h3>债权转让意向
                <div class="static"> <router-link :to="{ path: '/myAssignmentDebtIntentionPage' }">更多</router-link></div>
              </h3>
              <template>
                <el-table
                  :data="myAssignmentDebtIntention"
                  style="width: 100%">
                  <el-table-column
                    prop="projectName"
                    label="项目名称"
                    width="460">
                  </el-table-column>
                  <el-table-column
                    prop="createTime"
                    label="意向发送时间" :formatter="formatCreateTime">
                  </el-table-column>
                  <el-table-column
                    prop="disposeStatus"
                    label="当前状态" :formatter="formatDisposeStatus" >
                  </el-table-column>
                  <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                      <el-button type="default" @click="selectAssignmentDebtProject(scope.$index,scope.row)" size="small">查看项目</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </div>
            <!-- my list -->
            <div class="con mylist mt_42">
              <h1>我的成交记录</h1>
              <h3>我的借入(总金额 <span class="color_red">{{totalBorrowContractAmount}}</span> 元)
                <div class="static">  <router-link :to="{ path: '/myBorrowPage' }">更多</router-link></div>
              </h3>
              <template>
                <el-table
                  :data="borrow"
                  style="width: 100%">
                  <el-table-column
                    prop="projectName"
                    label="项目名称"
                    width="310">
                  </el-table-column>
                  <el-table-column
                    prop="contractAmount"
                    label="成交金额(元)">
                  </el-table-column>
                  <el-table-column
                    prop="transDate"
                    label="成交时间" :formatter="formatTransDate">
                  </el-table-column>
                  <el-table-column
                    prop="disposeStatus"
                    label="当前状态" :formatter="formatDisposeStatus" >
                  </el-table-column>
                  <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                      <el-button type="default" size="small" @click="selectBorrowProject(scope.$index,scope.row)">查看项目</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </div>

            <div class="con mylist mt_42">
                <h3>我的出借(总金额 <span class="color_red">{{totalLanContractAmount}}</span> 元)
                  <div class="static"> <router-link :to="{ path: '/MyLoanPage' }">更多</router-link></div>
                </h3>
                <template>
                  <el-table
                    :data="lan"
                    style="width: 100%">
                    <el-table-column
                      prop="projectName"
                      label="项目名称"
                      width="310">
                    </el-table-column>
                    <el-table-column
                      prop="contractAmount"
                      label="成交金额(元)">
                    </el-table-column>
                    <el-table-column
                      prop="transDate"
                      label="成交时间" :formatter="formatTransDate">
                    </el-table-column>
                    <el-table-column
                      prop="disposeStatus"
                      label="当前状态" :formatter="formatDisposeStatus">
                    </el-table-column>
                    <el-table-column
                      label="操作">
                      <template slot-scope="scope">
                        <el-button type="default" size="small" @click="selectLanProject(scope.$index,scope.row)">查看项目</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
            </div>

            <div class="con mylist mt_42">
              <h3>我的债转(总金额 <span class="color_red">{{AsDeTotalContractAmount}}</span> 元)
                <div class="static"> <router-link :to="{ path: '/myAssignmentDebtPage' }">更多</router-link></div>
              </h3>
              <template>
                <el-table
                  :data="assignmentDebt"
                  style="width: 100%">
                  <el-table-column
                    prop="projectName"
                    label="项目名称"
                    width="310">
                  </el-table-column>
                  <el-table-column
                    prop="contractAmount"
                    label="成交金额(元)">
                  </el-table-column>
                  <el-table-column
                    prop="transDate"
                    label="转让时间" :formatter="formatTransDate">
                  </el-table-column>
                  <el-table-column
                    prop="disposeStatus"
                    label="当前状态" :formatter="formatDisposeStatus">
                  </el-table-column>
                  <el-table-column
                    label="操作">
                    <template slot-scope="scope">
                      <el-button type="default" size="small" @click="selectAssignmentDebtProject(scope.$index,scope.row)">查看项目</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </div>

          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
  import util from '../../common/util'
  import  {reqMyLanIntention,reqMyBorrowIntention,reqMyLan,reqMyBorrow,reqMyBorrowById,reqMyLoanById,reqMyBorrowTotalLanContractAmount,reqMyLanTotalLanContractAmount,reqAssignmentDebt,reqMyAssignmentDebtIntention,reqMyAsDeTotalContractAmount} from "../../api/webUser-api"
  import {reqGetOneLoanProject,reqGetOneBorrowProject} from '../../api/projectManagement-api'
  export default {
    data() {
      return {
        borrow:[],
        lan:[],
        AsDeTotalContractAmount:[],
        assignmentDebt:[],
        lanIntention: [],
        myAssignmentDebtIntention:[],
        borrowIntention: [],
        totalBorrowContractAmount:'',
        totalLanContractAmount:'',
        form: {
          projectId: '',
          projectName: '',
          contractAmount: '',
          disposeStatus: '',
          transDate: '',
        },
        type: '',
        createTime: '',
      }
    },
    methods: {
      //我的意向
      //我的借入记录
      getMyBorrowIntention() {
        var id = window.sessionStorage.getItem('Authorization');
        reqMyBorrowIntention({userId: id}).then(res => {
          if (res.data.code == 1) {
            this.borrowIntention = res.data.data;
          }
        })
      },
      //我的意向
      //我的出借记录
      getMyLanIntention() {
        var id = window.sessionStorage.getItem('Authorization');
        reqMyLanIntention({userId: id}).then(res => {
          if (res.data.code == 1) {
            this.lanIntention = res.data.data;
          }
        })
      },
      //我的债转意向
      getMyAssignmentDebtIntention() {
        var id = window.sessionStorage.getItem('Authorization');
        reqMyAssignmentDebtIntention({userId: id}).then(res => {
          if (res.data.code == 1) {
            this.myAssignmentDebtIntention = res.data.data;
          }
        })
      },
      selectBorrowProject(index,row){
        this.$router.push({name: 'loanProjectDetail', query: {id: row.projectId}});
      },
      selectLanProject(index,row){
        this.$router.push({name: 'borrowProjectDetail', query: {id: row.projectId}});
      },
      selectAssignmentDebtProject(index,row){
        this.$router.push({name: 'assignmentDebtDetail', query: {id: row.projectId}});
      },
      //我的成交记录
      //我的借入成交记录
      getMyBorrow() {
        var id = window.sessionStorage.getItem('Authorization');
        reqMyBorrow({userId: id}).then(res => {
          if (res.data.code == 1) {
            this.borrow= res.data.data;
          }
        })
      },
      getTotalBorrowContractAmount(){
        var id = window.sessionStorage.getItem('Authorization');
        reqMyBorrowTotalLanContractAmount({userId: id}).then(res=>{
          this.totalBorrowContractAmount=res.data.data;
        })
      },

      //我的成交记录
      //我的出借成交记录
      getMyLan() {
        var id = window.sessionStorage.getItem('Authorization');
        reqMyLan({userId: id}).then(res => {
          if (res.data.code == 1) {
            this.lan = res.data.data;
          }
        })
      },
      //我的债权转让成交记录
      myAssignmentDebt(){
        var id = window.sessionStorage.getItem('Authorization');
        reqAssignmentDebt({userId: id}).then(res => {
          if (res.data.code == 1) {
            this.assignmentDebt = res.data.data;
          }
        })
      },
      myAsDeTotalContractAmount(){
        var id = window.sessionStorage.getItem('Authorization');
        reqMyAsDeTotalContractAmount({userId: id}).then(res => {
          if (res.data.code == 1) {
            this.AsDeTotalContractAmount = res.data.data;
          }
        })
      },
      getTotalLanContractAmount(){
        var id = window.sessionStorage.getItem('Authorization');
        reqMyLanTotalLanContractAmount({userId: id}).then(res=>{
          this.totalLanContractAmount=res.data.data;
        })
      },
      formatTransDate: function (row, colnm) {
        if (row.transDate) {
          return util.formatDate.format(new Date(row.transDate), 'yyyy-MM-dd');
        }
      },
      formatCreateTime: function (row, colnm) {
        if (row.createTime) {
          return util.formatDate.format(new Date(row.createTime), 'yyyy-MM-dd');
        }
      },
      formatType: function (row, colnm) {
        if (row.projectName == ''||row.projectName==null) {
          this.projectName=row.projectName;
          return '直接意向';
        }
        else  {
          return '项目意向'
        }
      },
      formatDisposeStatus: function (row, colnm) {
        if (row.disposeStatus == 0) {
          return '已成交'
        } else if (row.disposeStatus == 1) {
          return '未成交'
        } else {
          return '对接中'
        }
      },
    },
    mounted() {
      this.getMyBorrow();
      this.getMyBorrowIntention();
      this.getMyLan();
      this.myAssignmentDebt();
      this.getMyLanIntention();
      this.getMyAssignmentDebtIntention();
      this.getTotalLanContractAmount();
      this.getTotalBorrowContractAmount();
      this.myAsDeTotalContractAmount();

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/userCenter/MyBorrow.vue